<!-- CTN Invoice Format -->
<div class="imperial-invoice-container">
  <div class="invoice-page" *ngFor="let invoice of invoices; let i = index">

    <!-- Header Section -->
    <div class="invoice-header">
      <div class="company-logo-section">
        <div class="logo-circle">
          <span class="logo-text">SMJ</span>
        </div>
        <div class="company-tagline">
          <strong>Supreme</strong><br>
          <strong>Motors</strong><br>
          <small>PROSPERITY FOR ALL</small>
        </div>
      </div>

      <div class="company-details">
        <h2 class="company-name">IMPERIAL SOLUTIONS LTD.</h2>
        <div class="company-address">
          <p>2F-24 AOBADAI</p>
          <p>KITAKU KOBE 651-1231 JAPAN</p>
          <p><strong>TEL:</strong> +81-78-201-5360 <strong>FAX:</strong> +81-78-201-5374</p>
          <p><strong>E-MAIL:</strong> info@imperialsolutions.jp</p>
        </div>
      </div>
    </div>

    <!-- Invoice Title -->
    <div class="invoice-title">
      <h1>INVOICE</h1>
    </div>

    <!-- Main Content Grid -->
    <div class="invoice-content">

      <!-- Left Column -->
      <div class="left-column">

        <!-- Consignee Section -->
        <div class="section consignee-section">
          <div class="section-header">CONSIGNEE:</div>
          <div class="section-content">
            <p><strong>{{ invoice.order?.buyer_company_name || invoice.order?.buyer_consignee_name }}</strong></p>
            <p>{{ invoice.order?.buyer_street_address }}</p>
            <p>{{ invoice.order?.buyer_city }}</p>
            <p>{{ invoice.order?.buyer_country }}</p>
            <p>{{ invoice.order?.buyer_email_address }}</p>
            <p><strong>TEL:</strong> {{ invoice.order?.buyer_telephone_no }}</p>
          </div>
        </div>

        <!-- Notify Party Section -->
        <div class="section notify-section">
          <div class="section-header">NOTIFY PARTY:</div>
          <div class="section-content">
            <p><strong>{{ invoice.order?.buyer_company_name || invoice.order?.buyer_consignee_name }}</strong></p>
            <p>{{ invoice.order?.buyer_street_address }}</p>
            <p>{{ invoice.order?.buyer_city }}</p>
            <p>{{ invoice.order?.buyer_country }}</p>
          </div>
        </div>

        <!-- Port Information -->
        <div class="port-info">
          <div class="port-section">
            <div class="section-header">PORT OF LOADING:</div>
            <div class="section-content">
              <p><strong>ANY PORT IN JAPAN</strong></p>
            </div>
          </div>

          <div class="port-section">
            <div class="section-header">PORT OF DISCHARGING:</div>
            <div class="section-content">
              <p><strong>{{ invoice.order?.to_port }}, {{ invoice.order?.to_country }}</strong></p>
            </div>
          </div>
        </div>

        <!-- Shipping Details -->
        <div class="shipping-details">
          <div class="detail-row">
            <span class="label">SHIPPED PER:</span>
            <span class="value">{{ invoice.ship?.name || '-' }}</span>
          </div>

          <div class="detail-row">
            <span class="label">VOYAGE NO:</span>
            <span class="value">{{ invoice.ship?.voyage_no || '-' }}</span>
          </div>

          <div class="detail-row">
            <span class="label">ESTIMATED TIME OF DEPARTURE:</span>
            <span class="value">{{  invoice.ship?.sailing_date ? formatDate(invoice.ship.sailing_date) : '-' }}</span>
          </div>

          <div class="detail-row">
            <span class="label">ESTIMATED TIME OF ARRIVAL:</span>
            <span class="value">{{ invoice.ship?.arrival_date ? formatDate(invoice.ship.arrival_date) : '-' }}</span>
          </div>
        </div>

      </div>

      <!-- Right Column -->
      <div class="right-column">

        <!-- Invoice Details -->
        <div class="invoice-details-section">
          <div class="detail-row">
            <span class="label">INVOICE NO:</span>
            <span class="value"><strong>{{ invoice.invoice_number }}</strong></span>
          </div>

          <div class="detail-row">
            <span class="label">DATE:</span>
            <span class="value"><strong>{{ invoice.invoice_date ? formatDate(invoice.invoice_date) : '-' }}</strong></span>
          </div>
        </div>

        <!-- Bank Details -->
        <div class="section bank-section">
          <div class="section-header">BANK DETAILS:</div>
          <div class="section-content">
            <p><strong>BANK NAME:</strong> MIZUHO BANK LTD</p>
            <p><strong>BRANCH NAME:</strong> KOBE BRANCH</p>
            <p><strong>ACCOUNT NAME:</strong> IMPERIAL SOLUTIONS LTD</p>
            <p><strong>ACCOUNT NO:</strong> 1234567</p>
            <p><strong>SWIFT CODE:</strong> MHCBJPJT</p>
          </div>
        </div>

        <!-- Ship Type and Terms -->
        <div class="terms-section">
          <div class="detail-row">
            <span class="label">SHIP TYPE:</span>
            <span class="value">{{ invoice.order?.ship_type || 'RORO' }}</span>
          </div>

          <div class="detail-row">
            <span class="label">TRADE TERMS:</span>
            <span class="value">{{ invoice.order?.payment_terms || 'CFR' }}</span>
          </div>

          <div class="detail-row">
            <span class="label">PAYMENT TERMS:</span>
            <span class="value">{{ invoice.order?.payment_terms || 'T/T IN ADVANCE' }}</span>
          </div>
        </div>

        <!-- Destination -->
        <div class="destination-section">
          <div class="detail-row">
            <span class="label">C&F:</span>
            <span class="value"><strong>{{ invoice.order?.to_country }}</strong></span>
          </div>
        </div>

      </div>
    </div>

    <!-- Vehicle Details Section -->
    <div class="vehicle-section">
      <div class="vehicle-header">
        <div class="make-model">
          <span class="label">MAKE SMALL:</span>
        </div>

        <div class="vehicle-details-header">
          <span class="label">VEHICLE DETAILS:</span>
        </div>

        <div class="cost-calculation">
          <span class="label">COST CALCULATION (S)</span>
        </div>
      </div>

      <!-- Individual Vehicle Mode -->
      <div class="vehicle-content" *ngIf="viewMode !== 'merged' || !invoice.vehicles">
        <!-- Make and Model Column -->
        <div class="make-model-content">
          <div class="m3-weight-display">
            <div class="m3-weight-header">M3/Weight</div>
            <div class="m3-weight-value">{{ invoice.vehicle?.m3 || '-' }}/{{ invoice.vehicle?.weight || '-' }}</div>
          </div>
          <div class="make-value">{{ invoice.vehicle?.make }}</div>
        </div>

        <!-- Vehicle Details Column -->
        <div class="vehicle-details-content">
          <div class="specs-column">
            <div class="spec-row">
              <span class="spec-label">MFG YEAR:</span>
              <span class="spec-value">{{ invoice.vehicle?.year }}</span>
            </div>

            <div class="spec-row">
              <span class="spec-label">MODEL CODE:</span>
              <span class="spec-value">{{ invoice.vehicle?.body_type }}</span>
            </div>

            <div class="spec-row">
              <span class="spec-label">ENGINE:</span>
              <span class="spec-value">{{ invoice.vehicle?.engine }} CC</span>
            </div>

            <div class="spec-row">
              <span class="spec-label">MILEAGE:</span>
              <span class="spec-value">{{ invoice.vehicle?.mileage | number }} KM</span>
            </div>

            <div class="spec-row">
              <span class="spec-label">STOCK NUMBER:</span>
              <span class="spec-value">{{ invoice.vehicle?.stock_no }}</span>
            </div>
          </div>

          <div class="specs-column">
            <div class="spec-row">
              <span class="spec-label">FUEL:</span>
              <span class="spec-value">{{ invoice.vehicle?.fuel_type }}</span>
            </div>

            <div class="spec-row">
              <span class="spec-label">COLOR:</span>
              <span class="spec-value">{{ invoice.vehicle?.exterior_color }}</span>
            </div>

            <div class="spec-row">
              <span class="spec-label">TRANS:</span>
              <span class="spec-value">{{ invoice.vehicle?.transmission }}</span>
            </div>

            <div class="spec-row">
              <span class="spec-label">WEIGHT:</span>
              <span class="spec-value">-</span>
            </div>
          </div>
        </div>

        <!-- Cost Details Column -->
        <div class="cost-details">
          <div class="cost-row">
            <span class="cost-label">UNIT PRICE & FOB:</span>
            <span class="cost-value">USD<br>{{ formatCurrency(invoice.invoice_amount, invoice.item?.currency) }}</span>
          </div>
        </div>
      </div>

      <!-- Merged Vehicles Mode -->
      <div class="merged-vehicles-content" *ngIf="viewMode === 'merged' && invoice.vehicles">
        <div class="vehicles-table-container">
          <table class="vehicles-table">
            <thead>
              <tr>
                <!-- <th>Invoice #</th> -->
                <th>M3/Weight</th>
                <th>Vehicle Details</th>
                <th>Specifications</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let vehicle of invoice.vehicles; let idx = index">
                <!-- <td class="invoice-number">{{ vehicle.invoice_number }}</td> -->
                <td class="m3-weight-cell">
                  <div class="m3-weight-value">{{ vehicle.m3 || '-' }}/{{ vehicle.weight || '-' }}</div>
                </td>
                <td class="vehicle-details">
                  <div class="vehicle-name">{{ vehicle.make }} {{ vehicle.model }}</div>
                  <div class="vehicle-year">Year: {{ vehicle.year }}</div>
                  <div class="vehicle-chassis">Chassis: {{ vehicle.chassis_no }}</div>
                  <div class="vehicle-stock">Stock: {{ vehicle.stock_no }}</div>
                </td>
                <td class="vehicle-specs">
                  <div class="spec-item">Engine: {{ vehicle.engine }} CC</div>
                  <div class="spec-item">Mileage: {{ vehicle.mileage | number }} KM</div>
                  <div class="spec-item">Fuel: {{ vehicle.fuel_type }}</div>
                  <div class="spec-item">Color: {{ vehicle.exterior_color }}</div>
                  <div class="spec-item">Trans: {{ vehicle.transmission }}</div>
                </td>
                <td class="vehicle-amount">
                  {{ formatCurrency(vehicle.invoice_amount, vehicle.item?.currency) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Total Section -->
      <div class="total-section">
        <div class="total-row">
          <span class="total-label">TOTAL {{ viewMode === 'merged' && invoice.vehicles ? invoice.vehicles.length : 1 }} UNIT(S)</span>
          <span class="total-value">TOTAL C&F: {{ formatCurrency(invoice.invoice_amount, invoice.item?.currency) }}</span>
        </div>
      </div>
    </div>

    <!-- Footer Section -->
    <div class="invoice-footer">
      <div class="due-date-section">
        <div class="due-date">
          <span class="label">DUE DATE *</span>
        </div>
      </div>

      <div class="notes-section">
        <div class="notes-header">NOTES:</div>
        <div class="notes-content">
          <p>PLEASE INCLUDE PROFORMA NUMBERS IN THE REMITTANCE INFORMATION SECTION WHEN
          MAKING YOUR PAYMENT WE CERTIFY THAT THE GOODS ARE OF JAPANESE ORIGIN THE
          BUYER SHOULD BEAR THE COST OF BANK CHARGE WHEN REMITTING T/T. THE BUYER IS
          PURCHASING A RECONDITIONED VEHICLE MINOR ISSUES SUCH AS WEAK BATTERY, LACK
          OF COOLANT, MINOR SCRATCHES, DENTS, WORN TIRES, MINOR ELECTRICAL ISSUES
          OR THE TRANSPORT COMPARTMENT BEFORE MOVING THE VEHICLE FROM PORT TO THE
          FINAL DESTINATION.</p>
        </div>
      </div>

      <div class="signature-section">
        <div class="authorized-signature">
          <p><strong>AUTHORIZED SIGNATURE</strong></p>
          <div class="signature-line">
            <p><strong>Imperial Solutions</strong></p>
            <p><strong>D.S SETHI</strong></p>
          </div>
        </div>
      </div>
    </div>

    <!-- Page Break (except for last invoice) -->
    <div class="page-break" *ngIf="i < invoices.length - 1"></div>

  </div>
</div>
